export const calculateFinalPrice = (price, offerPrice, taxType = 'exclusive', taxApplicable = true) => {
    if (!price) return null;
    
    // Calculate discounted price
    // If offerPrice is provided, treat it as a Discount PERCENTAGE (e.g., 40 means 40% off)
    let sellingPrice = price;
    if (offerPrice > 0 && offerPrice < 100) {
        sellingPrice = Math.round(price - (price * offerPrice / 100));
    }
    
    // Resolve tax type (handling backward compatibility with taxApplicable boolean)
    const resolvedTaxType = taxType || (taxApplicable === false ? 'none' : 'exclusive');
    
    // Define standard GST percentage (can be moved to DB or .env later)
    const gstPercentage = 18;
    
    // Calculate final total
    let finalTotal = sellingPrice;
    if (resolvedTaxType === 'exclusive') {
        finalTotal = parseFloat((sellingPrice + (sellingPrice * gstPercentage) / 100).toFixed(2));
    }
    
    // Determine GST display text
    let gstText = '';
    if (resolvedTaxType === 'inclusive') {
        gstText = 'Inclusive of all taxes';
    } else if (resolvedTaxType === 'exclusive') {
        gstText = 'Exclusive of all taxes';
    } else {
        gstText = '';
    }
    
    return {
        basePrice: price,
        discountedPrice: sellingPrice,
        taxType: resolvedTaxType,
        finalTotal: finalTotal,
        gstText: gstText
    };
};
